<script context="module">
	import { ButtonType } from './buttons';
	export { ButtonType };
</script>

<script lang="ts">
	import { stateClassBuilder } from './buttons';

	export let className = '';
	export let id = '';
	export let name = '';
	export let label = '';
	export let title = label;
	export let type: ButtonType = ButtonType.primary;
	export let disabled = false;
	export let pressed = false;
	export let pressable = false;
	export let iconOnly = false;
	/**
	 * Non-interactive buttons have no button type/role, but just appear as buttons
	 */
	export let interactive = true;

	const baseClasses = 'flex items-center justify-center min-w-8 select-none font-weight-control text-sm outline-offset-2 transition-[padding] duration-200 ease-in-out h-[32px]';

	$: classes = `${className} ${iconOnly ? 'px-1.5' : 'sm:px-4'} ${baseClasses} ${stateClassBuilder(type, disabled, pressed)}`;
</script>

{#if interactive}
	<button
		on:click
		{id}
		{name}
		data-button-type={type}
		aria-pressed={pressable && pressed ? 'true' : (pressable ? 'false' : undefined)}
		aria-label={label}
		title={title}
		{disabled}
		class={classes}
	>
		<slot />
	</button>
{:else}
	<div
		{id}
		data-button-type={type}
		aria-pressed={pressable && pressed ? 'true' : (pressable ? 'false' : undefined)}
		aria-label={label}
		title={title}
		class={classes}
	>
		<slot />
	</div>
{/if}
